module.exports = __webpack_public_path__ + "static/img/report_bottom.3e2a4300.svg";